import api from './api';
  
 
// ============================================
// AUTHENTICATIONS
// ============================================
export const login = async (username, password) => {
try {
const response = await api.post('/auth/login/professional/', {
username,
password,
});
return response.data; // Assuming the backend returns a token
} catch (error) {
throw error;
}
};

export const logout = async () => {
try {
const response = await api.post('/auth/logout');
return response.data;
} catch (error) {
throw error;
}
};


// ============================================
// DASHBOARD 
// ============================================
export const getStats = async () => {
try {
const response = await api.get('/dashboard/home');
return response.data;
} catch (error) {
throw error;
}
};

export const updateProfile = async (userData) => {
try {
const response = await api.put('/professional/profile', userData);
return response.data;
} catch (error) {
throw error;
}
};

export const getProfile = async () => {
try {
const response = await api.get('/professional/profile');
return response.data;
} catch (error) {
throw error;
}
};

// ============================================
// SETTINGS - PERSONAL INFORMATION
// ============================================
export const getPersonalInfo = async () => {
try {
const response = await api.get('/settings/personal');
return response.data;
} catch (error) {
throw error;
}
};

export const updatePersonalInfo = async (data) => {
try {
const response = await api.put('/settings/personal', data);
return response.data;
} catch (error) {
throw error;
}
};

export const uploadProfileImage = async (file) => {
try {
const formData = new FormData();
formData.append('profile_image', file);

const response = await api.post('/settings/personal/profile-image', formData, {
headers: {
'Content-Type': 'multipart/form-data',
},
});
return response.data;
} catch (error) {
throw error;
}
};

export const changePassword = async (currentPassword, newPassword) => {
try {
const response = await api.put('/settings/personal/password', {
currentPassword,
newPassword
});
return response.data;
} catch (error) {
throw error;
}
};



// ============================================
// SETTINGS - PROFESSIONAL INFORMATION
// ============================================
export const getProfessionalInfo = async () => {
try {
const response = await api.get('/settings/professional');
return response.data;
} catch (error) {
throw error;
}
};

export const updateProfessionalInfo = async (data) => {
try {
const response = await api.put('/settings/professional', data);
return response.data;
} catch (error) {
throw error;
}
};




// ============================================
// SETTINGS - RESUME MANAGEMENT
// ============================================
export const uploadResume = async (file) => {
try {
const formData = new FormData();
formData.append('resume', file);

const response = await api.post('/resume/upload', formData, {
headers: {
'Content-Type': 'multipart/form-data',
},
});
return response.data;
} catch (error) {
throw error;
}
};

export const getResumeData = async () => {
try {
const response = await api.get('/settings/resume');
return response.data;
} catch (error) {
throw error;
}
};

// Skills
export const addSkill = async (skillData) => {
try {
const response = await api.post('/settings/resume/skills', skillData);
return response.data;
} catch (error) {
throw error;
}
};

export const updateSkill = async (skillId, skillData) => {
try {
const response = await api.put(`/settings/resume/skills/${skillId}`, skillData);
return response.data;
} catch (error) {
throw error;
}
};

export const deleteSkill = async (skillId) => {
try {
const response = await api.delete(`/settings/resume/skills/${skillId}`);
return response.data;
} catch (error) {
throw error;
}
};

// Experience
export const addExperience = async (experienceData) => {
try {
const response = await api.post('/settings/resume/experience', experienceData);
return response.data;
} catch (error) {
throw error;
}
};

export const updateExperience = async (experienceId, experienceData) => {
try {
const response = await api.put(`/settings/resume/experience/${experienceId}`, experienceData);
return response.data;
} catch (error) {
throw error;
}
};

export const deleteExperience = async (experienceId) => {
try {
const response = await api.delete(`/settings/resume/experience/${experienceId}`);
return response.data;
} catch (error) {
throw error;
}
};

// Education
export const addEducation = async (educationData) => {
try {
const response = await api.post('/settings/resume/education', educationData);
return response.data;
} catch (error) {
throw error;
}
};

export const updateEducation = async (educationId, educationData) => {
try {
const response = await api.put(`/settings/resume/education/${educationId}`, educationData);
return response.data;
} catch (error) {
throw error;
}
};

export const deleteEducation = async (educationId) => {
try {
const response = await api.delete(`/settings/resume/education/${educationId}`);
return response.data;
} catch (error) {
throw error;
}
};

// Certifications
export const addCertification = async (certificationData) => {
try {
const response = await api.post('/settings/resume/certifications', certificationData);
return response.data;
} catch (error) {
throw error;
}
};

export const updateCertification = async (certificationId, certificationData) => {
try {
const response = await api.put(`/settings/resume/certifications/${certificationId}`, certificationData);
return response.data;
} catch (error) {
throw error;
}
};

export const deleteCertification = async (certificationId) => {
try {
const response = await api.delete(`/settings/resume/certifications/${certificationId}`);
return response.data;
} catch (error) {
throw error;
}
};

// Projects
export const addProject = async (projectData) => {
try {
const response = await api.post('/settings/resume/projects', projectData);
return response.data;
} catch (error) {
throw error;
}
};

export const updateProject = async (projectId, projectData) => {
try {
const response = await api.put(`/settings/resume/projects/${projectId}`, projectData);
return response.data;
} catch (error) {
throw error;
}
};

export const deleteProject = async (projectId) => {
try {
const response = await api.delete(`/settings/resume/projects/${projectId}`);
return response.data;
} catch (error) {
throw error;
}
};



// ============================================
// SETTINGS - PROFESSIONAL DOCUMENTS
// ============================================
export const getDocuments = async (params) => {
try {
const response = await api.get('/settings/documents', { params });
return response.data;
} catch (error) {
throw error;
}
};

export const uploadDocument = async (file, documentData) => {
try {
const formData = new FormData();
formData.append(documentData.type, file);

Object.keys(documentData).forEach(key => {
formData.append(key, documentData[key]);
});

const response = await api.post('/settings/documents', formData, {
headers: {
'Content-Type': 'multipart/form-data',
},
});
return response.data;
} catch (error) {
throw error;
}
};

export const updateDocument = async (documentId, documentData) => {
try {
const response = await api.put(`/settings/documents/${documentId}`, documentData);
return response.data;
} catch (error) {
throw error;
}
};

export const deleteDocument = async (documentId) => {
try {
const response = await api.delete(`/settings/documents/${documentId}`);
return response.data;
} catch (error) {
throw error;
}
};


// ============================================
// SETTINGS - PREFERENCES
// ============================================
export const getPreferences = async () => {
try {
const response = await api.get('/settings/preferences');
return response.data;
} catch (error) {
throw error;
}
};

export const updatePreferences = async (preferences) => {
try {
const response = await api.put('/settings/preferences', preferences);
return response.data;
} catch (error) {
throw error;
}
};



// ============================================
// BILLING
// ============================================
export const getBillingInfo = async () => {
try {
const response = await api.get('/billing');
return response.data;
} catch (error) {
throw error;
}
};

export const getPackageFeatures = async () => {
try {
const response = await api.get('/billing/packages');
return response.data;
} catch (error) {
throw error;
}
};

export const updateAutoRenew = async (autoRenew) => {
try {
const response = await api.put('/billing/auto-renew', { 
package_auto_renew: autoRenew 
});
return response.data;
} catch (error) {
throw error;
}
};

export const getTransactionHistory = async (params) => {
try {
const response = await api.get('/billing/transactions', { params });
return response.data;
} catch (error) {
throw error;
}
};

export const getTransactionDetails = async (transactionId) => {
try {
const response = await api.get(`/billing/transactions/${transactionId}`);
return response.data;
} catch (error) {
throw error;
}
};

export const getUsageStats = async () => {
try {
const response = await api.get('/billing/usage');
return response.data;
} catch (error) {
throw error;
}
};

export const changePackage = async (newPackage) => {
try {
const response = await api.post('/billing/change-package', { newPackage });
return response.data;
} catch (error) {
throw error;
}
};

export const cancelSubscription = async () => {
try {
const response = await api.post('/billing/cancel');
return response.data;
} catch (error) {
throw error;
}
};




// ============================================
// NOTIFICATIONS 
// ============================================
export const notificationHeader = async () => {
try {
const response = await api.get('/notifications/header');
return response.data;
} catch (error) {
throw error;
}
};

export const notificationUpdate = async () => {
try {
const response = await api.put('/notifications/mark-read');
return response.data;
} catch (error) {
throw error;
}
};

export const notificationList = async ({ page, perPage }) => {
try{const res = await api.get(`/notifications?page=${page}&perPage=${perPage}`);
return res.data;
} catch (error) {
throw error;
}
};



// ============================================
// JOB MATCHING 
// ============================================
export const getMatching = async (params) => {
try {
const response = await api.get('/matching/jobs', {params});
return response.data;
} catch (error) {
throw error;
}
};

export const matchingUpdate = async (matchId, enable) => {
try {
const response = await api.put('/matching/jobs/'+matchId+'/auto-apply', { enable });
return response.data;
} catch (error) {
throw error;
}
};

export const matchingDelete = async (matchId) => {
try {
const response = await api.delete('/matching/jobs/'+matchId);
return response.data;
} catch (error) {
throw error;
}
};

export const matchingStats = async () => {
try {
const response = await api.get('/matching/stats');
return response.data;
} catch (error) {
throw error;
}
};

export const getMatchingDetails = async (id) => {
try {
const response = await api.get('/matching/jobs/'+id);
return response.data;
} catch (error) {
throw error;
}
};



// ============================================
// APPLICATIONS 
// ============================================
export const applyToJob = async (id) => {
try {
const response = await api.post('/matching/jobs/'+id);
return response.data;
} catch (error) {
throw error;
}
};

export const applicationsList = async (params) => {
try{  const res = await api.get('/applications', { params });
return res.data;
} catch (error) {
throw error;
}
};

export const applicationStats = async () => {
try{  const res = await api.get('/applications/stats');
return res.data;
} catch (error) {
throw error;
}
};

export const applicationUpdateStatus = async (appId, status) => {
try{  const res = await api.put(`/applications/${appId}/status`, { status });
return res.data;
} catch (error) {
throw error;
}
};


// ============================================
// INTERVIEWS 
// ============================================
export const interviewsList = async (params) => {
try{  const res = await api.get('/interviews', { params });
return res.data;
} catch (error) {
throw error;
}
};

export const interviewDetails = async (id) => {
try{  const res = await api.get('/interviews/details/'+id);
return res.data;
} catch (error) {
throw error;
}
};

export const interviewsStats = async () => {
try{  const res = await api.get('/interviews/stats');
return res.data;
} catch (error) {
throw error;
}
};

export const interviewsCreate = async (payload) => {
try{  const res = await api.post('/interviews/create/real', payload);
return res.data;
} catch (error) {
throw error;
}
};

export const createPracticeInterview = async (InterviewData) => {
try{  const res = await api.post('/interviews/create/practice', InterviewData);
return res.data;
} catch (error) {
throw error;
}
};

export const createPreparationInterview = async (InterviewData) => {
try{  const res = await api.post('/interviews/create/preparation', InterviewData);
return res.data;
} catch (error) {
throw error;
}
};

export const updateInterview = async (InterviewId, updateData) => {
try{  const res = await api.put('/interviews/update/'+InterviewId, updateData);
return res.data;
} catch (error) {
throw error;
}
};




// ============================================
// CAREER PIVOT 
// ============================================
/**
* Get user's current career profile
*/
export const getCurrentProfile = async () => {
try {
const response = await api.get('/career-pivot/profile');
return response.data;
} catch (error) {
throw error;
}
};

/**
* Analyze career pivot options using AI
*/
export const analyzeCareerPivots = async () => {
try {
const response = await api.get('/career-pivot/analyze');
return response.data;
} catch (error) {
throw error;
}
};

/**
* Save a career pivot exploration
*/
export const saveCareerPivot = async (pivotData) => {
try {
const response = await api.post('/career-pivot', pivotData);
return response.data;
} catch (error) {
throw error;
}
};

/**
* Get all career pivots for user
*/
export const getUserCareerPivots = async () => {
try {
const response = await api.get('/career-pivot');
return response.data;
} catch (error) {
throw error;
}
};

/**
* Get career pivot statistics
*/
export const getCareerPivotStats = async () => {
try {
const response = await api.get('/career-pivot/stats');
return response.data;
} catch (error) {
throw error;
}
};

/**
* Generate detailed transition plan
*/
export const generateTransitionPlan = async (careerPivotId) => {
try {
const response = await api.post(`/career-pivot/${careerPivotId}/transition-plan`);
return response.data;
} catch (error) {
throw error;
}
};

/**
* Update transition plan progress
*/
export const updateTransitionPlan = async (planId, updateData) => {
try {
const response = await api.put(`/career-pivot/transition-plan/${planId}`, updateData);
return response.data;
} catch (error) {
throw error;
}
};

/**
* Assess transition risks
*/
export const assessRisks = async (careerPivotId) => {
try {
const response = await api.get(`/career-pivot/${careerPivotId}/risks`);
return response.data;
} catch (error) {
throw error;
}
};

/**
* Find matching mentors
*/
export const findMentors = async (careerPivotId) => {
try {
const response = await api.get(`/career-pivot/${careerPivotId}/mentors`);
return response.data;
} catch (error) {
throw error;
}
};

/**
* Request mentorship session
*/
export const requestMentorship = async (mentorshipData) => {
try {
const response = await api.post('/career-pivot/mentorship/request', mentorshipData);
return response.data;
} catch (error) {
throw error;
}
};

/**
* Get user's mentoring sessions
*/
export const getMentoringSessions = async () => {
try {
const response = await api.get('/career-pivot/mentorship/sessions');
return response.data;
} catch (error) {
throw error;
}
};

/**
* Update session feedback and rating
*/
export const updateSessionFeedback = async (sessionId, feedbackData) => {
try {
const response = await api.put(
`/career-pivot/mentorship/session/${sessionId}/feedback`,
feedbackData
);
return response.data;
} catch (error) {
throw error;
}
};




// ============================================
// SUPPORT & HELP CENTER
// ============================================

/**
* Create a support ticket (authenticated user)
*/
export const createSupportTicket = async (ticketData) => {
try {
const response = await api.post('/tickets', ticketData);
return response.data;
} catch (error) {
throw error;
}
};

/**
* Create a public support ticket (visitor)
*/
export const createPublicSupportTicket = async (ticketData) => {
try {
const response = await api.post('/tickets/public', ticketData);
return response.data;
} catch (error) {
throw error;
}
};

/**
* Get all support tickets for authenticated user
*/
export const getSupportTickets = async (params) => {
try {
const response = await api.get('/tickets', { params });
return response.data;
} catch (error) {
throw error;
}
};

/**
* Get single ticket details
*/
export const getSupportTicket = async (ticketId) => {
try {
const response = await api.get(`/tickets/${ticketId}`);
return response.data;
} catch (error) {
throw error;
}
};

/**
* Get support statistics
*/
export const getSupportStats = async () => {
try {
const response = await api.get('/tickets/stats');
return response.data;
} catch (error) {
throw error;
}
};

/**
* Check public ticket status
*/
export const checkPublicTicketStatus = async (ticketId, email) => {
try {
const response = await api.get(`/tickets/public/${ticketId}`, {
params: { email }
});
return response.data;
} catch (error) {
throw error;
}
};



// ============================================
// SYSTEM STATUS
// ============================================

/**
* Get current system status (PUBLIC)
*/
export const getSystemStatus = async () => {
try {
const response = await api.get('/system-status');
return response.data;
} catch (error) {
throw error;
}
};

/**
* Subscribe to status update notifications
*/
export const subscribeToStatusUpdates = async (data) => {
try {
const response = await api.post('/system-status/subscribe', data);
return response.data;
} catch (error) {
throw error;
}
};

/**
* Update system status (ADMIN ONLY)
*/
export const updateSystemStatus = async (data) => {
try {
const response = await api.post('/system-status/update', data);
return response.data;
} catch (error) {
throw error;
}
};


/**
 * Get status history (ADMIN ONLY)
 */
export const getStatusHistory = async (params) => {
try {
const response = await api.get('/system-status/history', { params });
return response.data;
} catch (error) {
throw error;
}
};



// ============================================
// MISCELENEAUS 
// ============================================
export const countries = async () => {
try {
const response = await api.get('/countries/list');
return response.data;
} catch (error) {
throw error;
}
};


/**
* Initialize package upgrade/downgrade
* POST /api/payments/upgrade
*/
export const upgradePackage = async (newPackage) => {
try {
const response = await api.post('/payments/upgrade', { newPackage });
return response.data;
} catch (error) {
throw error;
}
};



/* 2.  build default object dynamically (no typing) */
import * as requests from './requests'; // self-import
export default requests;

